import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';

const ControlBar = VideoJS.getComponent('ControlBar');

class ASControlBar extends ControlBar {
    createEl() {
        return super.createEl('div', {
            className: 'as-control-bar vjs-control-bar',
            dir: 'ltr'
        });
    }
}

ASControlBar.prototype.options_ = {
    children: [
        Controls.PLAY_TOGGLE, {
            name: Controls.VOLUME_PANEL,
            children: [
                Controls.MUTE_TOGGLE,
                Controls.VOLUME_CONTROL,
            ]
        },
        Controls.PROGRESS_CONTROL,
        Controls.CURRENT_TIME_DISPLAY,
        Controls.CAPTIONS_BUTTON,
        Controls.SHARE_CONTROL,
        Controls.FULLSCREEN_TOGGLE,
    ]
};

VideoJS.registerComponent(Controls.CONTROL_BAR, ASControlBar);

export default ASControlBar;



// WEBPACK FOOTER //
// ./src/player/components/ASControlBar.js